const layout3 = `<div class="bg-[#F5F5F4] py-5 md:py-16">
                <div class="container mx-auto px-[15px] max-w-[1240px]">
                    <div class="space-y-5 md:space-y-[64px]">
                        <div class="grid xs:grid-cols-4 lg:grid-cols-12">
                            <p class="col-span-4 mb-1 md:mb-0 text-[24px] md:text-[36px] text-stone-800 font-medium leading-[32px] md:leading-[40px]">
                                About the{" "}
                                <br class="xs:hidden lg:inline-block" /> Desh
                                Travels
                            </p>
                            <p class="col-span-8 text-sm md:text-base text-stone-800 font-normal leading-[24 px]">
                                Desh Travels is a traditional name in the road
                                transport world of Bangladesh. When Bangladesh
                                was emerging as a country after independence,
                                Ramesh Chandra Ghosh engaged in passenger
                                transport services in 1973 and started Shyamoli
                                Paribahan from his district town Pabna.
                                <br /> <br />
                                Starting with 1 bus, now Shyamli has one of the
                                largest bus fleets in the country with around
                                500 AC/Non-AC luxury chair coach buses.
                            </p>
                        </div>

                        <div class="flex xs:items-start md:items-center flex-col md:flex-row !mb-5 md:!mb-[64px]">
                            <p class="xs:w-full md:w-1/3 xs:mb-2 md:mb-0 text-[24px] md:text-[36px] text-stone-800 font-medium leading-[32px] md:leading-[40px]">
                                Sister Concerns
                            </p>
                            <div class="xs:full md:w-2/3 max-md:mt-4 grid grid-cols-2 md:grid-cols-4 items-center gap-3 md:gap-6">
                                <div class="bg-white flex justify-center items-center py-2 rounded-xl">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/volvo.svg"
                                        width="64"
                                        height="auto"
                                        alt="icon"
                                    />
                                </div>
                                <div class="bg-white flex justify-center items-center py-2 rounded-xl">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/scania.svg"
                                        width="108"
                                        height="auto"
                                        alt="icon"
                                    />
                                </div>
                                <div class="bg-white flex justify-center items-center py-2 rounded-xl">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/isuzu.svg"
                                        width="128"
                                        height="auto"
                                        alt="icon"
                                    />
                                </div>
                                <div class="bg-white flex justify-center items-center py-2 rounded-xl">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/mercedes.svg"
                                        width="118"
                                        height="auto"
                                        alt="icon"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bg-red-600 py-5 md:py-[68px]">
                    <div class="container mx-auto px-[15px] max-w-[1240px]">
                        <div class="flex flex-col md:flex-row xs:justify-start md:justify-between xs:gap-3 md:gap-[129px]">
                            <p class="xs:w-full md:w-2/5 text-[24px] md:text-[36px] text-white font-medium leading-[32px] md:leading-[40px]">
                                Message from our{" "}
                                <br class="hidden md:inline-block" /> chairman
                            </p>
                            <div class="xs:w-full md:w-3/5 max-md:mt-4 bg-white flex gap-4 p-4 rounded-xl box-shadow-2">
                                <div class="min-w-[56px]">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/quote.svg"
                                        width="56"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                                <p class="text-base md:text-lg text-red-600 font-semibold italic">
                                    Starting with 1 bus, now Shyamli has one of
                                    the largest bus fleets in the country with
                                    around 500 AC/Non-AC luxury chair coach
                                    buses. Dolor augue curae montes eget
                                    sollicitudin diam praesent non mus in
                                    lobortis. Ligula magna himenaeos dictumst
                                    cubilia.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container mx-auto px-[15px] max-w-[1240px]">
                    <div class="space-y-[64px]">
                        <div class="lg:px-0 xl:px-[100px] py-5 md:py-[64px]">
                            <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6">
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-8.png"
                                        width="292"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-2.png"
                                        width="292"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-10.png"
                                        width="292"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-11.png"
                                        width="292"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-7.png"
                                        width="292"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-12.png"
                                        width="292"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-5.png"
                                        width="292"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-2.png"
                                        width="292"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bg-red-600 mb-5 md:mb-[64px] py-5 md:py-[68px]">
                    <div class="container mx-auto max-w-[1240px] px-[15px] gap-[138px]">
                        <div class="flex flex-col lg:flex-row xs:items-center lg:items-center justify-between sm:px-8 lg:px-0">
                            <p class="text-[24px] md:text-[36px] xs:text-center lg:text-left text-white font-medium leading-[32px] md:leading-[40px] xs:mb-6 lg:mb-0">
                                We are the most affordable{" "}
                                <br class="xs:hidden lg:inline-block" /> and
                                comfortable bus in the{" "}
                                <br class="xs:hidden lg:inline-block" />{" "}
                                country.
                            </p>
                            <div class="grid grid-cols-2 gap-3 md:gap-6 max-md:mt-3">
                                <div class="xs:min-w-min sm:w-[260px] bg-white flex flex-col justify-center items-center gap-1 py-4 rounded-xl">
                                    <span class="text-[36px] text-red-600 font-medium leading-[40px]">
                                        34
                                    </span>
                                    <span class="text-base text-[#292524] font-semibold leading-[24px]">
                                        Buses
                                    </span>
                                </div>
                                <div class="xs:min-w-min sm:w-[260px] bg-white flex flex-col justify-center items-center gap-1 py-4 rounded-xl">
                                    <span class="text-[36px] text-red-600 font-medium leading-[40px]">
                                        12
                                    </span>
                                    <span class="text-base text-[#292524] font-semibold leading-[24px]">
                                        Districts Covered
                                    </span>
                                </div>
                                <div class="xs:min-w-min sm:w-[260px] bg-white flex flex-col justify-center items-center gap-1 py-4 rounded-xl">
                                    <span class="text-[36px] text-red-600 font-medium leading-[40px]">
                                        60+
                                    </span>
                                    <span class="text-base text-[#292524] font-semibold leading-[24px]">
                                        Daily trips
                                    </span>
                                </div>
                                <div class="xs:min-w-min sm:w-[260px] bg-white flex flex-col justify-center items-center gap-1 py-4 rounded-xl">
                                    <span class="text-[36px] text-red-600 font-medium leading-[40px]">
                                        3100+
                                    </span>
                                    <span class="text-base text-[#292524] font-semibold leading-[24px]">
                                        Tickets sold per day
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container mx-auto px-[15px] max-w-[1240px]">
                    <div class="space-y-5 md:space-y-[64px]">
                        <div class="flex flex-col lg:flex-row justify-between gap-3 md:gap-6">
                            <div class="w-full lg:w-1/2 space-y-1 md:space-y-5">
                                <h2 class=" text-2xl md:text-4xl text-[#292524] font-medium">
                                    Mission and Vision
                                </h2>
                                <p class="text-sm md:text-base text-[#292524] font-normal">
                                    Starting with 1 bus, now Shyamli has one of
                                    the largest bus fleets in the country with
                                    around 500 AC/Non-AC luxury chair coach
                                    buses. Dolor augue curae montes eget
                                    sollicitudin diam praesent non mus in
                                    lobortis. Ligula magna himenaeos dictumst
                                    cubilia dolor morbi letius tempor in
                                    convallis.
                                </p>
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6">
                                    <div class="flex gap-5">
                                        <div class="min-w-8">
                                            <img
                                                src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/icon_rate_XL_light.svg"
                                                width="32"
                                                height="auto"
                                                alt="img"
                                            />
                                        </div>
                                        <div>
                                            <h4 class="text-base text-red-600 font-semibold leading-[24px]">
                                                Best Prices
                                            </h4>
                                            <p class="text-sm text-stone-800 font-normal leading-[20px]">
                                                Enjoy discounts at participating
                                                properties worldwide
                                            </p>
                                        </div>
                                    </div>
                                    <div class="flex gap-5">
                                        <div class="min-w-8">
                                            <img
                                                src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/icon_rate_XL_light.svg"
                                                width="32"
                                                height="auto"
                                                alt="img"
                                            />
                                        </div>
                                        <div>
                                            <h4 class="text-base text-red-600 font-semibold leading-[24px]">
                                                Best Prices
                                            </h4>
                                            <p class="text-sm text-stone-800 font-normal leading-[20px]">
                                                Enjoy discounts at participating
                                                properties worldwide
                                            </p>
                                        </div>
                                    </div>
                                    <div class="flex gap-5">
                                        <div class="min-w-8">
                                            <img
                                                src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/icon_rate_XL_light.svg"
                                                width="32"
                                                height="auto"
                                                alt="img"
                                            />
                                        </div>
                                        <div>
                                            <h4 class="text-base text-red-600 font-semibold leading-[24px]">
                                                Best Prices
                                            </h4>
                                            <p class="text-sm text-stone-800 font-normal leading-[20px]">
                                                Enjoy discounts at participating
                                                properties worldwide
                                            </p>
                                        </div>
                                    </div>
                                    <div class="flex gap-5">
                                        <div class="min-w-8">
                                            <img
                                                src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/icon_rate_XL_light.svg"
                                                width="32"
                                                height="auto"
                                                alt="img"
                                            />
                                        </div>
                                        <div>
                                            <h4 class="text-base text-red-600 font-semibold leading-[24px]">
                                                Best Prices
                                            </h4>
                                            <p class="text-sm text-stone-800 font-normal leading-[20px]">
                                                Enjoy discounts at participating
                                                properties worldwide
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="w-full xs:mx-auto lg:mx-0 lg:w-1/2">
                                <img
                                    src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-13.png"
                                    width="100%"
                                    height="auto"
                                    alt="img"
                                />
                            </div>
                        </div>

                        <div>
                            <h2 class="text-2xl md:text-4xl text-center text-[#292524] font-medium mb-4">
                                Our Exclusive Buses
                            </h2>
                            <div class="grid xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-6">
                                <div class="bg-white rounded-2xl overflow-hidden box-shadow-2">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-14.png"
                                        class="w-full !object-cover"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />
                                    <p class="text-base text-stone-800 font-semibold leading-[24px] px-4 pt-3 pb-4">
                                        Hyundai it elit tellus, luctus nec
                                        ullamcorper mattis, pulvinar
                                    </p>
                                </div>
                                <div class="bg-white rounded-2xl overflow-hidden box-shadow-2">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-15.png"
                                        class="w-full !object-cover"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />
                                    <p class="text-base text-stone-800 font-semibold leading-[24px] px-4 pt-3 pb-4">
                                        Hyundai it elit tellus, luctus nec
                                        ullamcorper mattis, pulvinar
                                    </p>
                                </div>
                                <div class="bg-white rounded-2xl overflow-hidden box-shadow-2">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-16.png"
                                        class="w-full !object-cover"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />
                                    <p class="text-base text-stone-800 font-semibold leading-[24px] px-4 pt-3 pb-4">
                                        Hyundai it elit tellus, luctus nec
                                        ullamcorper mattis, pulvinar
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`;

export default layout3;
